module.exports = __webpack_public_path__ + "static/media/flxc.2fdbb504.mp4";